module.exports = __webpack_public_path__ + "img/more.e3280442.svg";